export default __webpack_public_path__ + "9f2440b1368818a66612257f3471592c.png";